<fui-page>
    <fui-page-pane>
        <fui-page-header [hasToggle]="hasHeaderToggle" [isExtended]="isSelectMode"
                         [title]="title ? title : 'wbo.' + searchModel.getResource() + '.search.title'"
                         [description]="description">
            <ng-content select="wbo-search-form"></ng-content>
            <fui-page-header-nav>
                <ng-content select="fui-page-header-nav"></ng-content>
            </fui-page-header-nav>
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <fui-page-utility>
                    <div class="utility-refresh">
                        <fui-action (click)="refreshClicked()" [attr.title]="'wbo.common.button.refresh' | translate">
                            <fui-icon [height]="20" [icon]="'refresh'" [width]="20" class="utility-refresh-icon"></fui-icon>
                        </fui-action>
                        <fui-switch-control *ngIf="autoRefreshInterval" [(value)]="autoRefreshEnabled"
                                            [label]="'wbo.search.label.auto-refresh'">
                        </fui-switch-control>
                    </div>
                    <fui-pop-button *ngIf="!entityActions.length && showAddButton" (click)="newEntity()"
                                    id="search-button-new-entity"
                                    class="utility-button" [title]="'wbo.' + searchModel.getResource() + '.common.add'">
                        <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                    </fui-pop-button>
                    <div class="actions" *ngIf="entityActions.length">
                        <fui-commands [title]="actionsTitle" [showPopupForSingleItems]="true">
                            <fui-command [title]="'wbo.' + searchModel.getResource() + '.common.add'"
                                         (clicked$)="newEntity()"
                                         *ngIf="showAddButton"></fui-command>
                            <fui-command *ngFor="let action of entityActions" [title]="action.title"
                                         (clicked$)="clickAction(action)"></fui-command>
                        </fui-commands>
                    </div>
                </fui-page-utility>
                <fui-page-subject>
                    <div class="grid">
                        <ng-content select="wbo-search-grid"></ng-content>
                    </div>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
    <fui-page-footer *ngIf="isSelectMode">
        <ng-template #FUIPageFooterButtons>
            <div *ngIf="isMultiSelectMode" class="tally">
                <div class="tally-label">
                    <div class="tally-label-title" [ngPlural]="selectedRecords.length">
                        <ng-template ngPluralCase="=0">No items selected</ng-template>
                        <ng-template ngPluralCase="=1">1 item selected</ng-template>
                        <ng-template ngPluralCase="other">{{selectedRecords.length}} items selected</ng-template>
                    </div>
                </div>
            </div>
            <wbo-footer-spinner [label]="'wbo.common.label.generatingReport'"
                                [processing]="reportGenerationService && (reportGenerationService.running$ | async)"></wbo-footer-spinner>
            <fui-buttons>
                <wbo-cancel-button (click)="cancelSelection()"></wbo-cancel-button>
                <wbo-ok-button *ngIf="isMultiSelectMode" (click)="confirmSelection()"
                               [title]="'wbo.common.button.select'"></wbo-ok-button>
            </fui-buttons>
        </ng-template>
    </fui-page-footer>
</fui-page>
